module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":"This company has no users yet. Finish setup here, then invite the first user from your portfolio company list when you are ready."},"de":{"message":"Dieses Unternehmen hat noch keine Benutzer. Schließen Sie die Einrichtung hier ab und laden Sie den ersten Benutzer später über die Portfolio-Unternehmensliste ein."}}')
  delete Component.options._Ctor
}
